import React from 'react';
import { number } from 'prop-types';
import axios from 'axios';
import { Button } from '@fiverr-private/fit';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { I18n } from '@fiverr-private/i18n-react';
import { reportBigQueryClick } from '../../../utils/reporter';
import { bigQuerySeller } from '../../SellerLinks';
import './style.scss';

const SwitchToBuying = ({ sellerId }) => {
    const handleClick = async () => {
        try {
            const path = pathfinder('root', {}, { query: { force_buying_nav: true } });

            reportBigQueryClick(bigQuerySeller(sellerId, 'switch_to_buying'));

            await axios.post(pathfinder('users_switch_header_navigation'), {
                data: {
                    header_navigation_type: 'buying',
                },
            });

            window.location = path;
        } catch (e) {
            logger.error(e, {
                description: 'Cant switch to buying',
                flow: 'SidebarSwitchToBuying',
            });
        }
    };

    return (
        <Button
            color={Button.COLORS.BLACK}
            fill={Button.FILLS.GHOST}
            size={Button.SIZES.SMALL}
            className="switch-full-width-button"
            onClick={handleClick}
        >
            <I18n k="header.switch_to_buyer.title" />
        </Button>
    );
};

SwitchToBuying.propTypes = {
    sellerId: number.isRequired,
};

export default SwitchToBuying;
